import React from "react";
import "./PvgHero.css";
import { CommonObject } from "../CommonObject";

export default function PvgHero() {
  const scrollToServices = () => {
    const servicesSection = document.getElementById("services");
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="pvg-hero" id="home">
      <div className="pvg-hero-container">
        <div className="pvg-hero-content">
          <div className="pvg-hero-badge">
            <i className="fas fa-star"></i>
            <span>Trusted by 500+ Global Companies</span>
          </div>

          <h1 className="pvg-hero-title">
            <span className="pvg-hero-quote">
              "Empowering Lives. Enabling Growth."
            </span>
          </h1>

          <p className="pvg-hero-description">
            From cooks on demand to global trade and professional training,
            {CommonObject.CompanyName.PVG} makes life simpler. We deliver
            innovative solutions that drive growth and transform businesses
            worldwide.
          </p>

          <div className="pvg-hero-actions">
            <button
              className="pvg-btn pvg-btn-primary"
              onClick={scrollToServices}
            >
              Get Started Today
              <i className="fas fa-arrow-right"></i>
            </button>
            <button className="pvg-btn pvg-btn-secondary">
              Watch Overview
              <i className="fas fa-play-circle"></i>
            </button>
          </div>

          <div className="pvg-hero-stats">
            <div className="pvg-stat-item">
              <div className="pvg-stat-icon">
                <i className="fas fa-globe"></i>
              </div>
              <div className="pvg-stat-content">
                <span className="pvg-stat-number">50+</span>
                <span className="pvg-stat-label">Services</span>
              </div>
            </div>

            <div className="pvg-stat-item">
              <div className="pvg-stat-icon">
                <i className="fas fa-users"></i>
              </div>
              <div className="pvg-stat-content">
                <span className="pvg-stat-number">1000+</span>
                <span className="pvg-stat-label">Clients</span>
              </div>
            </div>

            <div className="pvg-stat-item">
              <div className="pvg-stat-icon">
                <i className="fas fa-award"></i>
              </div>
              <div className="pvg-stat-content">
                <span className="pvg-stat-number">15+</span>
                <span className="pvg-stat-label">Years Experience</span>
              </div>
            </div>
          </div>
        </div>

        <div className="pvg-hero-visual">
          <div className="pvg-visual-content">
            {/* Floating Cards */}
            <a href="/ClickaCook">
              <div className="pvg-floating-card pvg-card-1">
                <div className="pvg-card-icon">
                  <i className="fas fa-utensils"></i>
                </div>
                <div className="pvg-card-text">
                  <h4>ClickaCook</h4>
                  <p>Professional Chef Services</p>
                </div>
              </div>
            </a>

            <a href="/">
              <div className="pvg-floating-card pvg-card-2">
                <div className="pvg-card-icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <div className="pvg-card-text">
                  <h4>Global Trade</h4>
                  <p>International Business</p>
                </div>
              </div>
            </a>

            <a href="/IFMS_Home">
              <div className="pvg-floating-card pvg-card-4">
                <div className="pvg-card-icon">
                  <i className="fas fa-building"></i>
                </div>
                <div className="pvg-card-text">
                  <h4>Facility Management</h4>
                  <p>Integrated Facility Management Solutions</p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div className="pvg-scroll-indicator" onClick={scrollToServices}>
        <span>Explore Our Services</span>
        <div className="pvg-scroll-arrow">
          <i className="fas fa-chevron-down"></i>
        </div>
      </div>

      {/* Background Overlay */}
      <div className="pvg-hero-overlay"></div>
    </section>
  );
}
